import { GetUsersResItem } from '~hooks/queries/users/use-get-users-vt'

export const mockUsers: GetUsersResItem[] = [
  {
    sub: 'auth0|123',
    email: 'bob@test.dk',
    name: 'Bob',
    roles: [
      {
        sub: 'auth0|123',
        entity: 'poolpartner',
        id: 'CST',
        role: 'user',
        roleDisplayName: 'User',
        poolPartnerName: 'CST',
        poolPartnerKey: 'CST',
        partnerId: '234',
      },
      {
        sub: 'auth0|123',
        entity: 'poolpartner',
        id: 'CID',
        role: 'user',
        roleDisplayName: 'User',
        poolPartnerName: 'Cido Shipping',
        poolPartnerKey: 'CID',
        partnerId: '345',
      },
    ],
  },
  {
    sub: 'auth0|abc',
    email: 'jog@maersktankers.com',
    name: 'Johann',
    roles: [
      {
        sub: 'auth0|abc',
        entity: 'vessel',
        id: 'cde123',
        role: 'mtops',
        roleDisplayName: 'MT Ops',
        vesselName: 'Asp Sunrise',
        imoNumber: '9713014',
        pool: 'Chemicals 2',
        vesselId: 'cde123',
        poolPartnerKey: 'ASP',
      },
      {
        sub: 'auth0|abc',
        entity: 'vessel',
        id: '223aab',
        role: 'mtops',
        roleDisplayName: 'MT Ops',
        pool: 'MR',
        imoNumber: '9332169',
        vesselName: 'Atlantic Crown',
        vesselId: '223aab',
        poolPartnerKey: 'CID',
      },
    ],
  },
]
